/** @format */

import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { UtilityService } from '@shared/utils/services';

@Component({
	selector: 'pdp-component-stylitics-jumplink',
	imports: [CommonModule, HmfButtonComponent],
	templateUrl: './stylitics-jumplink.component.html',
	styleUrl: './stylitics-jumplink.component.scss'
})
export class StyliticsJumplinkComponent {
	private readonly utilityService = inject(UtilityService);

	readonly isMobile = input(true);
	readonly disabled = input(false);

	handleClick() {
		const stylitics = document.querySelector<HTMLElement>('pdp-component-stylitics');
		this.utilityService.scrollToElement(stylitics);
	}
}
